import React from 'react';
import styles from './index.module.less';
import PointsTag from '@base/snippets/PointsTag';
import { IProduct } from 'base/interfaces/product';
import cn from 'classnames';
import { useStore, observer } from 'base/store';
import site from 'pro/config/site';
import { Trans } from 'base/utils/i18n';

type IProps = {
    points: IProduct['points'];
}

const ProductPoints: React.FC<IProps> = (props) => {
    const { userStore } = useStore();
    if (userStore.isDealer()) {
        return null;
    }

    const {
        points
    } = props

    if (!points?.showTag) {
        return <></>
    }

    return (
        <div className={cn('flex', styles['info-points-wrap'])}>
            <PointsTag className={styles.points} hasBg={false} points={points}/>
            <div className={cn(styles['text'])}>
                <Trans
                    i18nKey="web_product_earn_points"
                    values={{
                        num: points?.value || 1,
                        brand: site.brand
                    }}
                    components={{ span: <span className={styles.value}/>}}
                />
            </div>
        </div>
    );
};

export default observer(ProductPoints)